import React from 'react';

const LinkBlock = (props) => {
  return (
    <a className="c-linkblock" href={props.FriendlyTargetUrl}>
      {props.Text}
    </a>
  );
};

export default LinkBlock;
